import React, {Component} from 'react';
import {Button} from "react-bootstrap";

class MessageModal extends Component {
  handleCloseModal = () => {
    this.props.onOk({close: true})
  };

  render() {
    const {t} = this.props;
    return (
      <div className={`message-modal-wrapper ${this.props.messageModal ? 'active' : ''}`} onClick={this.handleCloseModal}>
        <div className="message-modal" onClick={e => e.stopPropagation()}>
          <div className="message-modal--header">
            <h3 className="message-modal--title">{t("messageModal.title")}</h3>
          </div>
          <div className="message-modal--body">
            <p className="message-modal--text">{this.props.message}</p>
            {this.props.messageMail && Object.keys(this.props.currentUser).length === 0 ? <p className="message-modal--text">{this.props.messageMail}</p> : null}
          </div>
          <div className="message-modal--footer">
            <Button className="message-modal--btn" onClick={this.handleCloseModal}>Ok</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default MessageModal;